// JavaScript Document

jQuery(document).ready(function($) {
  $(".view_timer").each(function(index, target) {
    var startDate = $(this).attr("data-start-date");
    var endDate = $(this).attr("data-end-date");
    var nowDate = new Date();

    if (startDate) {
      startDate = new Date(startDate);
    }
    else {
      startDate = nowDate;
    }
    if (endDate) {
      endDate = new Date(endDate);
    }

    if (startDate <= nowDate && (!endDate || nowDate <= endDate)) {
      $(this).fadeIn();
    }
    else {
      $(this).hide();
    }
  });
});


//
//	タイマーで表示を管理したい要素に
//	class="view_timer" data-start-date="2017/8/31 16:31" data-end-date="2017/9/2 20:00"
//	 をつけてね
//




jQuery(function($){
	var now = new Date();
	var $target = $('.limitbnr');
	$($target).each(function () {
		var $this = $(this);
		var $className = $this[0].className.split(' ')[0];
		var $classNameSplit = $className.split('--');
		var $st = $classNameSplit[1].split('_');
		var $stYmd = $st[0];
		var $stTime = $st[1].replace(/-/g, ':');
		var $stDate = $stYmd.replace(/-/g, '/') + ' ' + $stTime + ':00';
		var startDay = new Date($stDate);
		var $end = $classNameSplit[2].split('_');
		var $endYmd = $end[0];
		var $endTime = $end[1].replace(/-/g, ':');
		var $endDate = $endYmd.replace(/-/g, '/') + ' ' + $endTime + ':00';
		var endDay = new Date($endDate);
		if ( startDay < now && now < endDay ){
			$this.show();
		}else{
			$this.hide();
		}
	});
});